import { render, staticRenderFns } from "./RouterChildGuard.vue?vue&type=template&id=80af1e7a&"
import script from "./RouterChildGuard.vue?vue&type=script&lang=ts&"
export * from "./RouterChildGuard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports